/**
 * 功能埋点
 */

/* eslint-disable */
import API from '@/api/index'

(function(w, d, s, q) {
	w[q] =w[q] || []; 
	var f=d.getElementsByTagName(s)[0],j=d.createElement(s); 
	j.async=true; 
	j.id='beacon-aplus'; 
	j.src='https://cdn.fcsc.cn/aliyunmd/203498814.js'; 
	f.parentNode.insertBefore(j, f);
})(window, document, 'script', 'aplus_queue');


// 阿里埋点配置	
aplus_queue.push({ action: 'aplus.setMetaInfo', arguments: ['aplus-rhost-v', API.aplus]  });
aplus_queue.push({ action: 'aplus.setMetaInfo', arguments: ['appKey', API.appKey]  })

// 开启手动pv
aplus_queue.push({
  action: 'aplus.setMetaInfo',
  arguments: ['aplus-waiting', 'MAN'],
});

//开启调试模式
aplus_queue.push({
  action: 'aplus.setMetaInfo',
  arguments: ['DEBUG', true],
});

//先开启全埋点能⼒
//aplus_queue.push({
//action: 'aplus.setMetaInfo',
//arguments: ['aplus-autotrack-enabled', true],
//});

/* 获取智富通信息  */
function getzftData (fun) {
	let appData = {}
	window.zftGetLocalConstFromAppTwo = function (data) {
		if (typeof data === 'object') {
			appData = data
		} else {
			appData = JSON.parse(data)
		}
		fun && fun(appData)
	}
	let isZFT = /(efortune)/i.test(window.navigator.userAgent)
	if (isZFT) { // 获取智富通登陆信息
		let app = window.navigator.appVersion.toLocaleLowerCase()
		const keyMap = ['accounttype=0', 'jyloginflag', 'mobilecode', 'account']
		if (app.indexOf('iphone') > 0) {
			try {
				window.webkit.messageHandlers.zftCallLocalConstFromApp2.postMessage(['reqlocal', keyMap, 'zftGetLocalConstFromAppTwo'])
			} catch (e) {
				window.zftCallLocalConstFromApp('reqlocal', keyMap, 'zftGetLocalConstFromAppTwo')
			}
		} else if (app.indexOf('android') > 0) {
			appData = JSON.parse(window.LocalFunction.getLocalVal(keyMap))
			fun && fun(appData)
		}
	} else {
		fun && fun(appData)
	}
}

window.aplusSetMetaInfo = function () {
	getzftData(function (appData) {
		if (appData.mobilecode) {
			aplus_queue.push({
			  action: 'aplus.setMetaInfo',
			  arguments: ['_user_id', appData.mobilecode],
			});
			// 设置全局参数
			aplus_queue.push({
			  action: 'aplus.appendMetaInfo',
			  arguments: ['globalproperty', {
			    mobile: appData.mobilecode
			  }]
			})
		}
		if (appData.jyloginflag > 1 ) {
			aplus_queue.push({
			  action:'aplus.record',
			  arguments:['$$_user_profile', 'OTHER', {
			    'usercode':appData.account
			  }]
			});
		}
	})
}
aplusSetMetaInfo()

export default function Buriedpoint ({fun, functionId, other, type}) {
	try {
		let params = {
			page_name: functionId,
			page_title: fun,
			serviceName: API.serviceName,
			serviceId: API.serviceId,
			function: fun,
			functionId: functionId
		}
		if (typeof other === 'object') {
			params = Object.assign(other, params)
		}
		if (type === 'EXP') {
			aplus_queue.push({
			  action: 'aplus.record',
			  arguments: [functionId, 'EXP',
			    Object.assign({
			      //必传参数
			      ts: new Date().getTime(), //当前时间戳
			    }, params),
			  ],
			});
		} else {
			aplus_queue.push({
			  action: 'aplus.sendPV',
			  arguments: [
			    {
			      is_auto: false,
			    },
			    Object.assign({
			      //必传参数
			      ts: new Date().getTime(), //当前时间戳
			    }, params),
			  ],
			});
		}
	} catch (e) {}
}
/* eslint-enable */


// WEBPACK FOOTER //
// ./src/servers/buriedpoint.js